import { withInstall } from '../../../../utils/with-install'
import Traffic from './Traffic.vue'

export const ElAmapLayerTraffic = withInstall(Traffic)
export default ElAmapLayerTraffic
